import * as sensortoolWasm from "@nova-rnd/sensortool-wasm"
import { lazy } from "nodash"

export const getSensorTool = lazy(async () => {
    if ("inited" in sensortoolWasm) {
        return sensortoolWasm
    }
    if (typeof window === "undefined") return {} as typeof sensortoolWasm
    const bytes = await fetch("/sensortool.wasm").then((res) => res.arrayBuffer())
    sensortoolWasm.initSync(bytes)
    return sensortoolWasm
})

export const initializeSensorToolFromModule = (module: WebAssembly.Module) =>
    sensortoolWasm.initSync(module)
